import Button from '@material-ui/core/Button'

const PrimaryButton = ({ children, ...props }) => <Button color="primary" variant="contained" disableElevation {...props}>{ children }</Button>

export default PrimaryButton
